module.exports = __webpack_public_path__ + "img/logo-sowos-by-columbus.eb5d48db.png";